import React from 'react';
import Providers from './navigation';

 export default function App() {
   return <Providers />;
 }
